export default __webpack_public_path__ + "media/images/react_icons/close_icon_black-c9858fe58ad9fcd7e47470640351c42b.svg";